import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTasaForm } from '../Validations/ValidationsTasa';

export default function EditTasaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        descripcion: '',
        aplicacion: '',
        padron: '',
        recaudador: '',
        importe: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTasa = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/tasas/${id}`);

                console.log('Datos recibidos:', response.data); // Debugging

                setFormData({
                    id: response.data.id ?? '',
                    descripcion: response.data.descripcion ?? '',
                    aplicacion: response.data.aplicacion ?? '',
                    padron: response.data.padron ?? '', // Evita undefined
                    recaudador: response.data.recaudador ?? '',
                    importe: response.data.importe ?? ''
                });
            } catch (err) {
                setError('Error al cargar los datos de la tasa.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchTasa();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log(`Campo cambiado: ${name}, Nuevo valor: ${value}`); // Debugging

        setFormData(prevState => ({
            ...prevState,
            [name]: name === 'importe' ? parseFloat(value) || '' : value
        }));

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateTasaForm(formData);

        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                await axios.put(`/tasas/${id}`, formData);
                navigate('/home/tasas');
            } catch (err) {
                setError('Error al actualizar la tasa. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8 text-blue-600">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-3xl mx-auto mt-10 bg-blue-50 p-6 rounded-lg shadow-lg border border-blue-200">
            <h2 className="text-3xl font-bold text-blue-600 text-center mb-6">Editar Tasa</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                {Object.entries(formData).map(([key, value]) => (
                    <div key={key}>
                        <label className="block text-blue-700 font-semibold mb-1 capitalize">{key}</label>
                        <input
                            type={key === 'importe' ? 'number' : 'text'}
                            name={key}
                            value={value}
                            onChange={handleChange}
                            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 ${errors[key] ? 'border-red-500' : 'border-blue-300'}`}
                            required={key !== 'id'}
                            readOnly={key === 'id'}
                        />
                        {errors[key] && <p className="text-red-500 text-xs italic mt-1">{errors[key]}</p>}
                    </div>
                ))}
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition duration-300 shadow-md"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Tasa'}
                </button>
            </form>
        </div>
    );
}


/* CORRECTO SALE VALOR CAMPO PADRON
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTasaForm } from '../Validations/ValidationsTasa';

export default function EditTasaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        descripcion: '',
        aplicacion: '',
        padron: '',
        recaudador: '',
        importe: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTasa = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/tasas/${id}`);
                
                console.log('Datos recibidos:', response.data); // Depuración

                setFormData({
                    id: response.data.id ?? '',
                    descripcion: response.data.descripcion ?? '',
                    aplicacion: response.data.aplicacion ?? '',
                    padron: response.data.padron ?? '', // Asegurar que no sea undefined
                    recaudador: response.data.recaudador ?? '',
                    importe: response.data.importe ?? ''
                });
            } catch (err) {
                setError('Error al cargar los datos de la tasa.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchTasa();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateTasaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                await axios.put(`/tasas/${id}`, formData);
                navigate('/home/tasas');
            } catch (err) {
                setError('Error al actualizar la tasa. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8 text-blue-600">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-3xl mx-auto mt-10 bg-blue-50 p-6 rounded-lg shadow-lg border border-blue-200">
            <h2 className="text-3xl font-bold text-blue-600 text-center mb-6">Editar Tasa</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                {Object.keys(formData).map((key) => (
                    <div key={key}>
                        <label className="block text-blue-700 font-semibold mb-1 capitalize">{key}</label>
                        <input
                            type={key === 'importe' ? 'number' : 'text'}
                            name={key}
                            value={formData[key]}
                            onChange={handleChange}
                            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 ${errors[key] ? 'border-red-500' : 'border-blue-300'}`}
                            required={key !== 'id'}
                            readOnly={key === 'id'}
                        />
                        {errors[key] && <p className="text-red-500 text-xs italic mt-1">{errors[key]}</p>}
                    </div>
                ))}
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition duration-300 shadow-md"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Tasa'}
                </button>
            </form>
        </div>
    );
}

*/


/* CORRECTO

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTasaForm } from '../Validations/ValidationsTasa';

export default function EditTasaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        descripcion: '',
        aplicacion: '',
        padron: '',
        recaudador: '',
        importe: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTasa = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/tasas/${id}`);
                setFormData({
                    id: response.data.id || '',
                    descripcion: response.data.descripcion || '',
                    aplicacion: response.data.aplicacion || '',
                    padron: response.data.padron || '',
                    recaudador: response.data.recaudador || '',
                    importe: response.data.importe || ''
                });
            } catch (err) {
                setError('Error al cargar los datos de la tasa.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchTasa();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateTasaForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            setError(null);
            try {
                await axios.put(`/tasas/${id}`, formData);
                navigate('/home/tasas');
            } catch (err) {
                setError('Error al actualizar la tasa. Por favor, intente de nuevo.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8 text-blue-600">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-3xl mx-auto mt-10 bg-blue-50 p-6 rounded-lg shadow-lg border border-blue-200">
            <h2 className="text-3xl font-bold text-blue-600 text-center mb-6">Editar Tasa</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                {Object.keys(formData).map((key) => (
                    <div key={key}>
                        <label className="block text-blue-700 font-semibold mb-1 capitalize">{key}</label>
                        <input
                            type={key === 'importe' ? 'number' : 'text'}
                            name={key}
                            value={formData[key]}
                            onChange={handleChange}
                            className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 ${errors[key] ? 'border-red-500' : 'border-blue-300'}`}
                            required={key !== 'id'}
                            readOnly={key === 'id'}
                        />
                        {errors[key] && <p className="text-red-500 text-xs italic mt-1">{errors[key]}</p>}
                    </div>
                ))}
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition duration-300 shadow-md"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Tasa'}
                </button>
            </form>
        </div>
    );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTasaForm } from '../Validations/ValidationsTasa';

export default function EditTasaForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '',
        descripcion: '',
        aplicacion: '',
        padron: '',
        recaudador: '',
        importe: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTasa = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/tasas/${id}`);
                setFormData({
                    id: response.data.id || '',
                    descripcion: response.data.descripcion || '',
                    aplicacion: response.data.aplicacion || '',
                    padron: response.data.padron || '',
                    recaudador: response.data.recaudador || '',
                    importe: response.data.importe || ''
                });
            } catch (err) {
                setError('Error al cargar los datos de la tasa.');
            } finally {
                setIsLoading(false);
            }
        };

        if (id) fetchTasa();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ''
        }));
    };

   
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Formulario enviado con datos:', formData); // Log para depurar
        const validationErrors = await validateTasaForm(formData);
        console.log('Errores de validación:', validationErrors); // Log de validación
        if (Object.keys(validationErrors).length === 0) {
          setIsLoading(true);
          setError(null);
          try {
            console.log('Actualizando datos en el servidor...');
            await axios.put(`/tasas/${id}`, formData);
            console.log('Actualización exitosa.');
            navigate('/home/tasas'); // Redirigir al listado después de guardar
          } catch (err) {
            setError('Error al actualizar la tasa. Por favor, intente de nuevo.');
            console.error('Error updating lugar:', err);
          } finally {
            setIsLoading(false);
          }
        } else {
          setErrors(validationErrors); // Mostrar errores si la validación falla
        }
      };



    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-2xl mx-auto mt-8">
            <h2 className="text-2xl font-bold mb-4">Editar Tasa</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-1">ID</label>
                    <input
                        type="text"
                        name="id"
                        value={formData.id}
                        className="w-full p-2 border rounded"
                        required
                        readOnly
                    />
                </div>
                <div>
                    <label className="block mb-1">Descripción</label>
                    <input
                        type="text"
                        name="descripcion"
                        value={formData.descripcion}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.descripcion ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.descripcion && <p className="text-red-500 text-xs italic">{errors.descripcion}</p>}
                </div>
                <div>
                    <label className="block mb-1">Aplicación</label>
                    <input
                        type="text"
                        name="aplicacion"
                        value={formData.aplicacion}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.aplicacion ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.aplicacion && <p className="text-red-500 text-xs italic">{errors.aplicacion}</p>}
                </div>
                <div>
                    <label className="block mb-1">Padrón</label>
                    <input
                        type="text"
                        name="padron"
                        value={formData.padron}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.padron ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.padron && <p className="text-red-500 text-xs italic">{errors.padron}</p>}
                </div>
                <div>
                    <label className="block mb-1">Recaudador</label>
                    <input
                        type="text"
                        name="recaudador"
                        value={formData.recaudador}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.recaudador ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.recaudador && <p className="text-red-500 text-xs italic">{errors.recaudador}</p>}
                </div>
                <div>
                    <label className="block mb-1">Importe</label>
                    <input
                        type="number"
                        name="importe"
                        value={formData.importe}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded ${errors.importe ? 'border-red-500' : ''}`}
                        required
                    />
                    {errors.importe && <p className="text-red-500 text-xs italic">{errors.importe}</p>}
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
                    disabled={isLoading}
                >
                    {isLoading ? 'Actualizando...' : 'Actualizar Tasa'}
                </button>
            </form>
        </div>
    );
}
*/